export default {
      id: "bin-usage",
      viewBox: "0 0 107 120",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#bin",
      toString: function () {
        return this.url;
      }
    }